module.exports = "<div ng-if=\"storePicker.fulfilmentInfo.FulfilmentMethod === 'Pick Up' && storePickerPanelService.deliverySearch.FulfilmentStoreID && storePicker.delivery.allowed\r\n            && !isMobile\"\r\n\t class=\"feature-promo--container animated fadeInUp\"\r\n\t ng-class=\"{'feature-promo--container_hide': hideFeaturePromo}\">\r\n\r\n\t<button ng-click=\"close()\"\r\n\t\t  class=\"pull-right icon--plus icon--remove\"\r\n\t\t  aria-hidden=\"true\"\r\n\t\t  role=\"button\"\r\n\t\t  tabindex=\"0\">\r\n\t</button>\r\n\r\n\t<feature-delivery></feature-delivery>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/feature-promo/feature-promo-template.html
 ** module id = 935
 ** module chunks = 1
 **/